import { create } from 'zustand';
import { ApiUtils, CustomerApi, CustomerDataItem, CustomerSearchParams, RequestStrategyEnum } from '@shared/api';

interface ICustomersStore {
  loading: boolean;
  error: string | null;
  customers: CustomerDataItem[];
  getCustomers: (params?: CustomerSearchParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCustomersLookupStore = create<ICustomersStore>((set) => ({
  loading: false,
  error: null,
  customers: [],

  getCustomers: ApiUtils.wrapperApi(async (params: CustomerSearchParams = {}, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await CustomerApi.getCustomers(params, signal);
      set({ customers: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ customers: [], loading: false, error: null }),
}));
